import http from "./http";
import config from "../common/config";

/*
* 应收账款接口
* project-receive-controller
* 图片1.1接口
* */
// 删除对应录入日期的应收数据
const deleteAllReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete('finance-web/receive/deleteAll', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
// 确认导入应收账款，会将该录入日期覆盖
const doImportReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('finance-web/receive/doImport?enterDate='+ reqParam.enterDate, reqParam.projectReceiveVOList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 导出应收账款
const exportReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/receive/export', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取最大有效日期
const getMaxDateReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web//receipts/analysis/maxDate', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
// 导入应收账款
const importReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('finance-web/receive/import', reqParam, false,false,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询应收数据
const getListReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/receive/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};


/*
* 应付账款接口
* project-pay-controller
* 图片1.2接口
* */

// 删除对应录入日期的应付数据
const deleteAllPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete('finance-web/pay/deleteAll', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
// 确认导入应付账款，会将该录入日期覆盖
const doImportPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('finance-web/pay/doImport?enterDate='+reqParam.enterDate, reqParam.projectPayVOList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 导出应付账款
const exportPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/export', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

// 获取最大有效日期
const getMaxDatePay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/getMaxDate', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

// 导入应付账款
const importPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('finance-web/pay/import', reqParam, false,false,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询应付数据
const getListPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

/*
* 应收账款接口
* receive-analysis-controller
* 图片2.接口
* */
//应收账款统计
const getReceiveAnalysisAuditAmount = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/receipts/analysis/auditAmount', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目部看板
const getReceiveAnalysisAuditAmountDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/receipts/analysis/auditAmount/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目看板
const getReceiveAnalysisAuditAmountProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/receipts/analysis/auditAmount/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//获取最大有效日期
const getReceiveMaxDate = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web//receipts/analysis/maxDate', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

//获取项目部已设置内容
const queryDeptSetting = (param) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/analysis/queryDeptSetting',param).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//设置项目部
const createOrUpdateDeptSetting = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('finance-web/pay/analysis/createOrUpdateDeptSetting', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//项目部下拉
const getReceiveDropDownDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/receipts/analysis/dropDown/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目下拉
const getReceiveDropDownProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/receipts/analysis/dropDown/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

//收入成本看板项目下拉
const getReceiveProjectList = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('contract-web/project/queryProjectListByDeptId', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
/*
* 付款申请接口
* pay-analysis-controller
* 图片3.接口
* */
//付款申请首页统计
const getPayAnalysis = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/analysis', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目部看板
const getPayAnalysisDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/analysis/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目看板
const getPayAnalysisProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/analysis/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//获取最大有效日期
const getPayMaxDate = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/getMaxDate', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目部下拉
const getPayDropDownDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/dropDown/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目下拉
const getPayDropDownProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/pay/dropDown/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

//导入应收账款数据源接口
const uploadProjectReceiveService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(
         "finance-web/receive/import",
          param,
          false,
          false,
          true
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
  
  
  //确认导入应收账款数据源接口
  const confirmuploadProjectReceiveService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(
          "finance-web/receive/doImport",
          param,
          false      
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  //导入应付账款数据源接口
const uploadProjectPayService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(
          "finance-web/pay/import",
          param,
          false,
          false,
          true
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
  
  
  //确认导入应付账款数据源接口
  const confirmProjectPayService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(
          "finance-web/pay/doImport",
          param,
          false      
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
  const exportExcelService2 = (url, param, needTrim = true) => {
    let baseUrl = config.baseUrl + "/contract-web";
    return new Promise((resolve, reject) => {
      //let exportUrl = `${baseUrl}${url}?`;
      let exportUrl = url;
      // for (let key in param) {
      //     if (param[key]) {
      //         exportUrl += `${/\?$/.test(exportUrl) ? '' : '&'}${key}=${encodeURI(param[key])}`;
      //         console.log(exportUrl)
      //     }
      // }
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = needTrim ? exportUrl.replace(/\s*/g, "") : exportUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
        let self = this;
        elemIF.onload = function() {
          reject();
        };
      } catch (e) {
        console.error(e);
      }
    });
  };

  //getTemplate下载应收账款模板
const getReceiveTemplate = param => {
    return new Promise((resolve, reject) => {
      http
        .get("finance-web/oss/template/receive", {"category":param})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
//下载应付账款模板
  const getPayTemplate = param => {
    return new Promise((resolve, reject) => {
      http
        .get("finance-web/oss/template/pay", {"category":param})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  //收入成本毛利统计
const getProfitCostAmount = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/grossProfit/analysis', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目部看板
const getProfitCostAmountDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/grossProfit/analysis/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目看板
const getProfitCostAmountProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('finance-web/grossProfit/analysis/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
export {
    exportExcelService2,
    getReceiveTemplate,
    getPayTemplate,
    //应收账款接口
    deleteAllReceive,
    doImportReceive,
    exportReceive,
    getMaxDateReceive,
    importReceive,
    getListReceive,
    //应付账款
    deleteAllPay,
    doImportPay,
    exportPay,
    getMaxDatePay,
    importPay,
    getListPay,
    //应付帐单接口
    getReceiveAnalysisAuditAmount,
    getReceiveAnalysisAuditAmountDept,
    getReceiveAnalysisAuditAmountProject,
    getReceiveMaxDate,
    queryDeptSetting,
    createOrUpdateDeptSetting,
    getReceiveDropDownDept,
    getReceiveDropDownProject,
    getReceiveProjectList,
    //导入相关接口
    uploadProjectReceiveService,
    confirmuploadProjectReceiveService,
    uploadProjectPayService,
    confirmProjectPayService,
    //付款申请接口
    getPayAnalysis,
    getPayAnalysisDept,
    getPayAnalysisProject,
    getPayMaxDate,
    getPayDropDownDept,
    getPayDropDownProject,
    //收入成本毛利统计
    getProfitCostAmount,
    getProfitCostAmountDept,
    getProfitCostAmountProject,
}
